import {updateUserTraits, parseUTMParams} from '@commercial-website/analytics'
import {initConsent} from '@commercial-website/consent'
import {initObservability} from '@commercial-website/observability'
import type {GatsbyBrowser} from 'gatsby'

import {isExperimentsReady, loadExperiments} from '@/utils/experiments-client'
import createTrackingForExperiments from '@/utils/track-page-split-experiments'
import {sessionTrackingProperties} from '@/utils/track-session'

export const onClientEntry: GatsbyBrowser['onClientEntry'] = () => {
    // Start fetching experiment assignments immediately; the consent gate below waits on
    // its readiness before loading Segment, so the first analytics event carries the traits.
    const experimentsLoaded = loadExperiments(window.location.pathname)

    initConsent({
        portalId: process.env.GATSBY_HUBSPOT_PORTAL_ID ?? '',
        writeKey: process.env.GATSBY_SEGMENT_WRITE_KEY!,
        amplitudeKey: process.env.GATSBY_AMPLITUDE_KEY,
        env: process.env.GATSBY_ACTIVE_ENV,
        isReady: isExperimentsReady,
    })
    initObservability({
        url: process.env.GATSBY_GRAFANA_ENDPOINT!,
        app: {
            name: 'commercial-helios',
            version: '1.0.0',
            environment: 'product-production',
        },
        sessionTracking: {
            enabled: true,
            samplingRate: 0.05,
        },
        paused: process.env.GATSBY_ACTIVE_ENV !== 'production',
    })

    // Object.fromEntries() polyfill
    if (!Object.fromEntries) {
        Object.defineProperty(Object, 'fromEntries', {
            value(entries: any[]) {
                return [...entries].reduce((obj, [key, val]) => {
                    obj[key] = val
                    return obj
                }, {})
            },
        })
    }

    experimentsLoaded.then(() => {
        updateUserTraits({
            ...sessionTrackingProperties(),
            ...parseUTMParams(),
            ...createTrackingForExperiments(),
        })
    })
}
